import { Component, Prop, Emit, Watch, Vue } from "vue-property-decorator";
import Modal from "@/components/modalBase/modalBase";
import { Action, Getter, State, Mutation } from "vuex-class";
import moment from "moment";

@Component({
  components: {
    Modal
  }
})
export default class ModalAddress extends Vue {
  @Prop({ default: false }) show!: Boolean;

  // Getters
  @Getter getCity;
  @Getter getCurrentProgram;
  @Getter getCurrentAddress;
  @Getter getCurrentCityZone;

  // Mutations
  @Mutation CURRENT_PROGRAM;
  @Mutation CURRENT_CITY_ZONE;

  // Attributes
  availableDays = [];
  hora = ''
  availableHourRanges = [];
  currentProgram = {
    day: null,
    hourRange: ""
  };
  days = []
  workingDay = null
  dayProgram = null
  dayName = null

  mounted() {
    this.setAvailableWeekDays();
    this.setDefaultDay();
    this.setAvailableHourRanges();
    this.setDefaultHourRange();
  }

  @Watch('getCurrentAddress', { deep: true })
  onAddressChange() {
    this.resetModal();
    this.setAvailableWeekDays();
    this.setDefaultDay();
    this.setAvailableHourRanges();
    this.setDefaultHourRange();
    if (this.getCurrentProgram && this.getCurrentProgram.hourRange === "on_demand") {
      this.CURRENT_PROGRAM(this.currentProgram);
    }
  }

  resetModal() {
    this.currentProgram = {
      day: null,
      hourRange: ""
    };
    this.availableDays = [];
    this.availableHourRanges = [];
  }

  @Watch("workingDay")
  onWorkingDay(val) {
    this.$emit("workingDay", val);
  }

  get getCheck() {
    return this.currentProgram && this.currentProgram.day && this.currentProgram.hourRange;
  }

  formatHourRange(value) {
    let hour1 = value.split(",")[0].trim();
    let hour2 = value.split(",")[1].trim();
    hour1 = moment(hour1, "HH:mm");
    hour2 = moment(hour2, "HH:mm");
    return hour1.format("hh:mm A") + " - " + hour2.format("hh:mm A");
  }

  setAvailableWeekDays() {
    let daysAvailables = [1, 2, 3, 4, 5, 6];
    const deliverySchedule = this.getCurrentCityZone.delivery_schedule;
    if (this.getCurrentCityZone && deliverySchedule) {
      const tempWeekdays = deliverySchedule.weekdays ? deliverySchedule.weekdays : [];
      if(tempWeekdays.length) {
        tempWeekdays.forEach((item) => {
          daysAvailables.push(parseInt(item));
        });
        daysAvailables = [...tempWeekdays];
      }
    }
    let startDay = moment(new Date());
    let nextDay = startDay.clone();
    if(this.getTime() < 24) {
      nextDay.add(0, "days");
    }
    else {
      nextDay.add(0, "days");
    }
    let endDay = startDay.clone();
    endDay.add(2, "days");
    let dayOfWeek = -1;
    while (nextDay.isSameOrBefore(endDay)) {
      dayOfWeek = nextDay.day();
      let found = false;
      for(let i = 0; i < daysAvailables.length && !found; i++) {
        if(dayOfWeek == daysAvailables[i]) {
          found = true;
        }
      }
      if (found) {
        const nextDayClone = nextDay.clone();
        nextDayClone.set('hour', 0);
        nextDayClone.set('minute', 0);
        nextDayClone.set('second', 0);
        this.availableDays.push(nextDayClone);
      } else {
        endDay.add(1, "days");
      }
      nextDay.add(1, "days");
    }
  }

  setAvailableHourRanges() {
    const deliverySchedule = this.getCurrentCityZone.delivery_schedule;
    if(deliverySchedule && deliverySchedule.hour_range.length !== 0) {
          this.availableHourRanges = [...deliverySchedule.hour_range];
      
    } else {
      this.availableHourRanges.push("13:00 , 20:00");
    }
  }

  setDefaultDay() {
    if(!this.currentProgram.day) {
      this.currentProgram.day = this.availableDays[0];
      let objFecha = new Date(this.currentProgram.day);
      let extra = objFecha.getDay();
      this.dayName = extra;
      console.log(this.dayName);
      console.log(extra);

    }
  }

  setDefaultHourRange() {
    if(this.currentProgram.hourRange.length === 0) {
      const randomIndex = this.randomIntFromInterval();
      this.currentProgram.hourRange = this.formatHourRange(this.availableHourRanges[randomIndex]);
    }
  }

  randomIntFromInterval() { // min and max included 
    const floor = 0;
    const top = this.availableHourRanges.length-1;
    let response =  Math.floor(Math.random() * (top- floor + 1) + floor);
    return response;
  }

  pickDay(day) {
    if(day) {
      day.set('hour', 0);
      day.set('minute', 0);
      day.set('second', 0);
      this.currentProgram.day = day;
      let objFecha1 = new Date(day);
      let extra = objFecha1.getDay();
      this.dayName = extra
      
      
    }
  }

  getTime() {
    let actualDate = new Date();
    let hours = actualDate.getHours();
    return hours
  }

  

  onSaveProgram() {
    this.CURRENT_PROGRAM(this.currentProgram);
    this.modalClose();
  }

  modalClose() {
    this.$emit("close");
  }

  @Watch('getCurrentCityZone')
  onCityZoneChange() {
    this.availableDays = [];
    this.availableHourRanges = [];
    this.currentProgram = {
      day: null,
      hourRange: ""
    };
    this.days = []
    this.setAvailableWeekDays();
    this.setDefaultDay();
    this.setAvailableHourRanges();
    this.setDefaultHourRange();
  }
}
